export const $ = jQuery;
export const w = $(window);